/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CustomFilterV2 } from '../../../../components/v2';
import { STATUS_FILTER_OPTIONS } from '../../RelatorioDigitacao/constants';
import {
  EXPORT_TIPO_SERVICO_OPTIONS,
  getDefaultExportFilter,
} from './constants';

const ExportFilterDialog = ({ open, onClose, authData, onExport }) => {
  const defaultFilter = useMemo(
    () => getDefaultExportFilter(authData),
    [authData],
  );

  return (
    <CustomFilterV2
      variant="dialog"
      open={open}
      onClose={onClose}
      title="Exportar relatório"
      fullWidth
      confirmButtonText="Exportar"
      defaultFilter={defaultFilter}
      appliedFilter={defaultFilter}
      fields={[
        { field: 'useDates', useDateTypes: true, useDateTypesReadOnly: true },
        { field: 'useCodigo', codigoLabel: 'Código NSIR', md: 4, xs: 12 },
        { field: 'useMalha', md: 4, xs: 12 },
        { field: 'usePolo', md: 4, xs: 12 },
        { field: 'useSubestacao', md: 4, xs: 12 },
        { field: 'useAlimentador', md: 4, xs: 12 },
        {
          field: 'useSearchSelect',
          key: 'tipoServicos',
          label: 'Tipo de Serviço',
          multiSelect: true,
          md: 6,
          xs: 12,
          options: EXPORT_TIPO_SERVICO_OPTIONS,
        },
        { field: 'useSubTipoServico', md: 6, xs: 12 },
        {
          field: 'useNsirStatus',
          customStatus: STATUS_FILTER_OPTIONS,
          multiSelect: true,
          md: 12,
          xs: 12,
        },
      ]}
      onFilter={(filterData) => {
        onExport(filterData);
        onClose();
      }}
    />
  );
};

ExportFilterDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  authData: PropTypes.object.isRequired,
  onExport: PropTypes.func.isRequired,
};

export default ExportFilterDialog;
